/*!

=========================================================
* Paper Health React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Button, Card, CardHeader, CardBody, CardTitle, InputGroup, InputGroupText, Input, Row, Col } from "reactstrap";
import moment from 'moment-timezone';
import GraphHP from 'views/GraphHP';



class Health extends React.Component {

	constructor(props) {
		super(props);

		this.allZoomLevels = [ 1, 2, 3, 7, 14, 30, 3*30, 6*30, 1*365, 2*365, 3*365 ];
		this.defaultZoomLevel = 3;

		this.state = {
			isAuthorized: localStorage.getItem('isAuthorized'),
			password: '',
			systolic: '',
			diastolic: '',
			when: moment.unix(Date.now() / 1000).tz('America/Los_Angeles').format('MMM D  HH:mm'),
			zoomOffset: 0,
			zoomLevel: this.allZoomLevels[this.defaultZoomLevel],
			lastPosX: 0,
			lastPosY: 0,
			mouseButton: "up",
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleAuthorizationPassword = this.handleAuthorizationPassword.bind(this);
		this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
		this.handleWheel = this.handleWheel.bind(this);
		this.handleMove = this.handleMove.bind(this);
		this.handleMouseButton = this.handleMouseButton.bind(this);
	}


	handleAuthorizationPassword( ev ) {
		ev.preventDefault();

		if ( this.state.password === '00' ) {
			this.setState( { isAuthorized: true } );
			localStorage.setItem('isAuthorized', true );
		}
	}

	setPassword(val) {
		this.setState( { password: val } );
	}


	loginFirst() {
		return (
			<div className="Login">
			  <form onSubmit={this.handleAuthorizationPassword}>
				<InputGroup name="password">
				  <InputGroupText> Unlock Code </InputGroupText>
				  <Input
					value={this.state.password}
					onChange={e => this.setPassword(e.target.value)}
				  />
				</InputGroup>
				<Button block type="submit">
				  Login
				</Button>
			  </form>
			</div>
		);

	}

	handleMouseButton(ev) {
		if (ev.type === "mousedown") {
			this.setState({ mouseButton: "down"});
		} else {
			this.setState({ mouseButton: "up"});
		}
	}

	handleMove(ev) {
		if ( this.state.mouseButton === "down" ) {
			let zo = this.state.zoomOffset;

			let dx = this.state.lastPosX - ev.pageX;
			let dy = this.state.lastPosY - ev.pageY;

			if ( dy !== 0 ) {
				if ( dx > 0 ) {
					zo -= this.state.zoomLevel / 24;
					if ( zo < 0 ) {
						zo = 0;
					}
				} else {
					zo += this.state.zoomLevel / 24;
					if ( zo > 1000 ) {
						zo = 1000;
					}
				}

				this.setState({ lastPosX: ev.pageX, lastPosY: ev.pageY });
				this.setState({ zoomOffset: zo });
			}
		}
	}

	handleWheel(ev) {
		// console.dir( ev );

		let idxZoomLevel = this.allZoomLevels.findIndex( (lvl) => lvl >= this.state.zoomLevel);

		if ( ev.deltaY < 0 ) {
			idxZoomLevel += 1;
			if ( idxZoomLevel >= this.allZoomLevels.length ) {
				idxZoomLevel = this.allZoomLevels.length - 1;
			}
		} else if ( ev.deltaY > 0 ) {
			idxZoomLevel -= 1;
			if ( idxZoomLevel < 0 ) {
				idxZoomLevel = 0;
			}
		} else {
		}

		/* disable scrollwheel changing zoom level by commenting the next line */
		// this.setState({ zoomLevel: this.allZoomLevels[idxZoomLevel] });
	}

	handleOnKeyDown( ev ) {
		// console.log(`handleOnKeyDown(kc = ${ev.keyCode} key = ${ev.key} which = ${ev.which} code = ${ev.code})`);
		// console.dir( ev );

		let keyName = ev.key;

		let zo = this.state.zoomOffset;
		let idxZoomLevel = this.allZoomLevels.findIndex( (lvl) => lvl >= this.state.zoomLevel);

		switch (keyName) {
			case '0':
				idxZoomLevel = this.defaultZoomLevel;
				zo = 0;
				break;

			case 'Delete':
				console.log("Deleting localStorage!");
				localStorage.removeItem("David_1");
				localStorage.removeItem("Kathleen_1");
				localStorage.removeItem("dataFurnace");
				localStorage.removeItem("undefined_1");
				localStorage.removeItem("undefined_2");
				localStorage.removeItem("undefined_3");
				localStorage.removeItem("undefined_4");
				break;

			case '-':
			case '_':
			case 'ArrowDown':
				idxZoomLevel += 1;
				if ( idxZoomLevel >= this.allZoomLevels.length ) {
					idxZoomLevel = this.allZoomLevels.length - 1;
				}
				break;

			case '+':
			case '=':
			case 'ArrowUp':
				idxZoomLevel -= 1;
				if ( idxZoomLevel < 0 ) {
					idxZoomLevel = 0;
				}
				break;

			case 'l':
			case '<':
			case ',':
			case 'ArrowRight':
				zo -= this.state.zoomLevel / 2;
				if ( zo < 0 ) {
					zo = 0;
				}
				break;

			case 'h':
			case '>':
			case '.':
			case 'ArrowLeft':
				zo += this.state.zoomLevel / 2;
				if ( zo > 1000 ) {
					zo = 1000;
				}
				break;

			default:
				break;
		}
		this.setState({ zoomLevel: this.allZoomLevels[idxZoomLevel], zoomOffset: zo });
		// console.log(`onKeyUp(${keyName},e,handle)    zoomLevel = ${this.allZoomLevels[idxZoomLevel]} zoomOffset = ${zo}`);
	}


	handleChange(e) {
		// console.log(`setting {[e.target.name]} = ${e.target.value}}`);
		this.setState({[e.target.name]: e.target.value});
	}

	async handleSubmit(e) {
		console.log(`A BP of ${this.state.systolic}/${this.state.diastolic} was submitted`);
		e.preventDefault();
		try {
			let url = `https://beccue.com/insert-bp.php?systolic=${this.state.systolic}&diastolic=${this.state.diastolic}&when=${this.state.when}`;
			let res = await fetch( url );
			await res.json();
			if (res.status === 200) {
				console.log(`bp sent successfully`);
				this.setState({ systolic: '', diastolic: '', when: '' });
			} else {
				console.log("Some error occured");
			}
		} catch (err) {
			console.log(err);
		}
	}

	render() {

		if ( ! this.state.isAuthorized ) {
			return (
			<div className="content"
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}>
				{this.loginFirst()}
			</div>
			);
		}

		return (
			<div className="content" onKeyDown={this.handleOnKeyDown} onWheel={(e) => this.handleWheel(e)} onMouseMove={this.handleMove} onMouseDown={this.handleMouseButton} onMouseUp={this.handleMouseButton} tabIndex="0" >

			  <Row>
				<Col md="12">
				  <Card>
					<CardHeader>
					  <CardTitle tag="h5"> Blood Pressure (Days: {this.state.zoomLevel * 7}) </CardTitle>
					  <p className="card-category"> David + Kathleen </p>
					</CardHeader>
					<CardBody style={{marginTop: -10}}>
						<GraphHP graphType="bp" label="David" height={250} urlData={"/getdata-bp.php?who=dab"} zoomLevel={this.state.zoomLevel * 7} zoomOffset={this.state.zoomOffset} />
					</CardBody>
				  </Card>
				</Col>
			  </Row>

			  <Row>
				<Col>
					<form onSubmit={this.handleSubmit}>
						<label>
						Blood Pressure :
						<input type="text" name="systolic" size="5" value={this.state.systolic} onChange={this.handleChange} />
						/
						<input type="text" name="diastolic" size="5" value={this.state.diastolic} onChange={this.handleChange} />
						</label>
						<label>
						&nbsp;
						&nbsp;
						When:
						<input type="text" name="when" size="8" value={this.state.when} onChange={this.handleChange} />
						</label>
						&nbsp;
						<input type="submit" value="Store BP" />
					</form>
				</Col>
			  </Row>

			  <Row>
				<Col>
					<div class="mb-8" >
						&nbsp;
					</div>
				</Col>
			  </Row>

			  <Row>
				<Col md="12">
				  <Card>
					<CardHeader>
					  <CardTitle tag="h5"> Weight (Days: {this.state.zoomLevel * 7}) </CardTitle>
					  <p className="card-category"> David + Kathleen </p>
					</CardHeader>
					<CardBody style={{marginTop: -10}}>
					  <Row>
						<Col md="6" xs="5">
							<GraphHP graphType="weight" label="David" width={1200} height={250} urlData={"/getdata-weight.php?who=dab"} zoomLevel={this.state.zoomLevel * 21} zoomOffset={this.state.zoomOffset} />
						</Col>
						<Col md="6" xs="5">
							<GraphHP graphType="weight" label="Kathleen" width={1200} height={250} urlData={"/getdata-weight.php?who=kwb"} zoomLevel={this.state.zoomLevel * 21} zoomOffset={this.state.zoomOffset} />
						</Col>
					  </Row>
					</CardBody>
				  </Card>
				</Col>
			  </Row>

			  <Row>
				<Col>
				  <Card>
					<CardHeader>
					  <CardTitle tag="h5"> Christian Healthcare Ministries </CardTitle>
					  <p className="card-category">
							Referral Link for CHM
						</p>
					</CardHeader>
					<CardBody style={{marginTop: -10}}>
						<a href="https://christianhealthcareministries.referralrock.com/l/CHM00362467/" target="_blank" rel="noopener noreferrer">
							David and Kathleen's referral link for
							<img src="https://info.chministries.org/hubfs/ChristianHealthcareMinistries_December2019/images/chm-logo-full.png" alt="CHM" />
						</a>
					</CardBody>
				  </Card>
				</Col>
			  </Row>

			</div>
		);
	}
}

export default Health;
